import { AgencyId, Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import { adminAgencyQueryKey } from "../agency.keys";

export const useAdminFetchAgency = (id: AgencyId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: adminAgencyQueryKey(id),
		queryFn: async () => {
			try {
				return await get<{ props: Dtos.Admin.Agency.Get.Response }>(`/v2/admin/agencies/${id}`);
			} catch (error) {
				// Handle 404 errors specifically to return null, indicating no agency found
				if (error instanceof ApiError && error.statusCode === 404) {
					return null;
				}

				throw error; // Re-throw other errors to be handled by the caller
			}
		},
	});

	return {
		agency: data?.props,
		agencyError: error,
		agencyLoading: isLoading,
	};
};
